var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFblogoblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#000000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.82,226.56l-5,40.42a13.48,13.48,0,0,1-13.35,11.83H271v169q-10.37.94-21,.94a234.14,234.14,0,0,1-46.18-4.59V278.81H153.47a8.44,8.44,0,0,1-8.4-8.42V219.81a8.44,8.44,0,0,1,8.4-8.42h50.35V135.53c0-46.55,37.58-84.28,83.94-84.28h58.75a8.43,8.43,0,0,1,8.39,8.43v50.57a8.43,8.43,0,0,1-8.39,8.42h-42A33.65,33.65,0,0,0,271,152.39v59h70.5A13.49,13.49,0,0,1,354.82,226.56Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFblogoblack);
export default __webpack_public_path__ + "static/media/fblogoblack.328b0b669f1689b9fa0b4c7b637b2ed2.svg";
export { ForwardRef as ReactComponent };